export const sortByDate = (arr) => {
  return arr.slice().sort(function (a, b) {
    const dateA = new Date(a.smokeTime);
    const dateB = new Date(b.smokeTime);
    return dateB > dateA ? -1 : 1;
  });
};
